import { render, staticRenderFns } from "./IButton.vue?vue&type=template&id=45abc43b&"
import script from "./IButton.vue?vue&type=script&lang=js&"
export * from "./IButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports